<template>
  <div class="main">
    <report-top v-if="!scan">
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-row-click="$emit('obj', $event)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openUpdateArriveTime(row, index)"
          >到达时间</Button
        >
        <Button size="small" @click="openUpdateCustomsStatus(row, index)"
          >通关状态</Button
        >
        <Button size="small" @click="openUpdateStatus(row, index)"
          >任务状态</Button
        >
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
      @tab="now = $event"
    >
      <tableForm
        slot="transportGoodsList"
        ref="transportGoodsList"
        :forms="transportGoodsListForms"
        :item1="transportGoodsListItem"
        v-model="item.transportGoodsList"
        height="200"
        :hideBtn="true"
      >
      </tableForm>
      <Button
        slot="btnLeft"
        v-show="now == '基本信息'"
        type="success"
        @click="openForm = true"
        >选择订单</Button
      >
      <span>{{ lydic["addressPrice"] }}</span>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新任务状态" width="400" ref="renwuzhuangtai">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>
    <form-model title="确认到达现场时间" width="400" ref="daodashijian">
      <Button slot="btn" type="primary" @click="updateArriveTime"
        >提交表单</Button
      >
    </form-model>
    <form-model title="更新通关状态" width="400" ref="tongguanzhuangtai">
      <Button slot="btn" type="primary" @click="updateCustomsStatus"
        >提交表单</Button
      >
    </form-model>
    <Modal
      v-model="openForm"
      title="订单号"
      fullscreen
      footer-hide
      width="1000"
    >
      <dingdanhao :scan="true" :checkMore="true" @objs="reobj"></dingdanhao>
    </Modal>
  </div>
</template>
<script>
var ordersGoodsList = [];
import dingdanhao from "./xitongkaidan.vue";
export default {
  components: { dingdanhao },
  props: ["scan"],
  data() {
    return {
      isAdd: false,
      openForm: false,
      now: "基本信息",
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "运单号",
          key: "no",
          sort: 0,
        },
        {
          title: "运单状态",
          key: "status2", //0--带调度 1--等发车 2--已发车 3--运输中 4--已送达 5--未签收 6--已签收 7--取消 8--异常
          sort: 0.1,
        },
        {
          title: "通关状态",
          key: "customsStatus2",
          sort: 0.1,
        },

        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 300,
          align: "center",
          fixed: "right",
        },
      ],

      tableData: [],
      item: {
        xd: 0,
        xs: 0,
        yd: 0,
        ys: 0,
        groupId: "",
        no: "",
        carId: "",
        carNo: "",
        driverId: "",
        driverAccount: "",
        driver: "",
        driverIdHk: "",
        driverHk: "",
        cabinetNo: "",
        sixOno: "",
        bpMode: 1,
        carType: "3T吨车",
        timeS: Date.now() + 86400000 * 1,
        addressS: "",
        addressD: "",
        timeD: Date.now() + 86400000 * 1.2,
        arriveTime: Date.now() + 86400000,
        filePath: "",
        remark: "",
        extendFields: "",
        transportGoodsList: ordersGoodsList,
      },
      transportGoodsListForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
          width: 180,
          required: true,
        },
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
        },
        
        {
          title: "体积",
          key: "volume",
          type: "InputNumber",
          required: true,
        },
        {
          title: "件数",
          key: "amount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "重量",
          key: "weight",
          type: "InputNumber",
          required: true,
        },
        {
          title: "条码",
          key: "barCode",
          type: "Input",
          //required: true,
        },
        {
          title: "型号",
          key: "model",
          type: "Input",
          //required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      transportGoodsListItem: {
        //id: 0,
        name: "手机",
        ono: "",
        barCode: "", //条码/编码
        volume: 0, //体积(立方)
        model: "", //型号
        amount: 0, //件数
        weight: 0,
        imgPath: "",
        remark: "",
        //keyWork: "",
        //idList: [],
      },
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: new Date(2023, 4, 1).getTime(),
        endTime: new Date(2023, 6, 1).getTime(),
        no: "",
        carNo: "",
        driver: "",
        sixOno: "",
        bpMode: true,
        carType: "",
        addressD: "",
        addressS: "",
        status: -1, //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          required: true,
          type: "selectCar",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "驾驶员",
          key4: "driverAccount",
          key1: "driver",
          required: false,
          type: "selectUser",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "香港司机",
          key4: "driverAccountHk",
          key1: "driverHk",
          required: false,
          val: "",
          type: "selectUser",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "柜号",
          key: "cabinetNo",
          required: false,
          type: "Input",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "六联单号",
          key: "sixOno",
          required: false,
          type: "Input",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: true,
          span: 6,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
          fenlei: "基本信息",
        },
        {
          title: "车辆类型",
          key: "carType",
          required: true,
          type: "Select",
          selectItems: [
            "3T吨车",
            "5T吨车",
            "8T吨车",
            "10T吨车",
            "12T吨车",
            "16T吨车",
            "20GP柜车",
            "40GP柜车",
            "45GP柜车",
            "20HQ柜车",
            "40HQ柜车",
            "45HQ柜车",
          ],
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "装车时间",
          key: "timeS",
          key2: "timeS2",
          formate: "datetime",
          required: true,
          type: "lyyymmdd",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "始发地",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          required: true,
          type: "Select",
          selectItems: [],
          //selectItems: [],
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "目的地",
          key: "addressD",
          keyX: "xd",
          keyY: "yd",
          required: true,
          type: "Select",
          selectItems: [],
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "卸货时间",
          key: "timeD",
          key2: "timeD2",
          formate: "datetime",
          required: true,
          type: "lyyymmdd",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "到场时间",
          key: "arriveTime",
          key: "arriveTime2",
          required: false,
          type: "lyyymmdd",
          span: 6,
          fenlei: "基本信息",
        },
        /* {
          title: "相关文件",
          key: "filePath",
          required: false,
          val: "",
          type: "lyPhoto",
        }, */
        {
          title: "备注信息",
          key: "remark",
          required: false,
          type: "Input",
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "订单配载",
          key: "transportGoodsList",
          slotForm: "transportGoodsList",
          required: true,
          noTable: true,
          hideLabel: true,
          span: 24,
          fenlei: "基本信息",
        },
      ],
      searchForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "运单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      updateStatusItem: {
        status: "0", //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
        no: "",
        customsStatus: "0", //0-未通关，1-已通关
      },
      updateStatusForms: [
        {
          title: "运单状态",
          key: "status",
          required: true,
          type: "Select1",
          st: "orderStataus",
          span: 24,
        },
        {
          title: "通关状态",
          key: "customsStatus",
          required: true,
          type: "Select1",
          st: "customsStatus",
          span: 24,
        },
      ],

      updateArriveTimeItem: {
        status: 0,
        no: "",
        customsStauts: 0,
      },
      updateArriveTimeForms: [
        {
          title: "运单状态",
          key: "status",
          required: true,
          type: "Select1",
          st: "orderStataus",
          span: 24,
        },
        {
          title: "通关状态",
          key: "customsStatus",
          required: true,
          type: "Select1",
          st: "customsStatus",
          span: 24,
        },
      ],

      updateCustomsStatusItem: {
        status: "0", //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
        no: "",
        customsStatus: "0", //0-未通关，1-已通关
      },
      updateCustomsStatusForms: [
        {
          title: "运单状态",
          key: "status",
          required: true,
          type: "Select1",
          st: "orderStataus",
          span: 24,
        },
        {
          title: "通关状态",
          key: "customsStatus",
          required: true,
          type: "Select1",
          st: "customsStatus",
          span: 24,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status = String(data[i].status);
          data[i].customsStatus = String(data[i].customsStatus);
          data[i].customsStatus2 = this.$t(
            "customsStatus." + data[i].customsStatus
          );
          data[i].status2 = this.$t("orderStataus." + data[i].status);
          data[i].timeD2 = this.utils.time(data[i].timeD, "yymmddhhmm");
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
          data[i].arriveTime2 = this.utils.time(
            data[i].arriveTime,
            "yymmddhhmm"
          );
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var table = this.$refs.transportGoodsList.yanzheng();

      if (table != true) {
        this.$Message.error(table);
        return;
      }
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.getdis();
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.getdis();
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openUpdateStatus(row) {
      this.updateStatusItem = JSON.parse(JSON.stringify(row));
      this.$refs.renwuzhuangtai.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus() {
      var a = this.$refs.renwuzhuangtai.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.renwuzhuangtai.close();
          this.getList();
        }
      });
    },

    openUpdateArriveTime(row) {
      this.updateStatusItem.status = row.status; //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
      this.updateStatusItem.no = row.no;
      this.updateStatusItem.customsStatus = row.customsStatus; //0-未通关，1-已通关
      this.$refs.daodashijian.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateArriveTime() {
      var a = this.$refs.daodashijian.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-ctc/transport/updateArriveTime",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.daodashijian.close();
          this.getList();
        }
      });
    },

    openUpdateCustomsStatus(row) {
      this.updateCustomsStatusItem.no = row.no;
      this.$refs.tongguanzhuangtai.reach(
        this.updateCustomsStatusForms,
        this.updateCustomsStatusItem
      );
    },
    updateCustomsStatus() {
      var a = this.$refs.tongguanzhuangtai.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-ctc/transport/updateCustomsStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.tongguanzhuangtai.close();
          this.getList();
        }
      });
    },

    reobj(v) {
      this.item.ono = v.no;
      this.openForm = false;
      ordersGoodsList.splice(0,100)
      for (let i = 0; i < v.length; i++) {
        var data;
        if (v[i].isFdpz) {
          data = v[i].ordersGoodsList;
          for (let j = 0; j < data.length; j++) {
            var obj = {
              pnumber: data[j].pnumber,
              ono: data[j].ono,
              storeName: "",
              name: data[j].name,
              barCode: data[j].barCode,
              volume: data[j].volume,
              model: data[j].model,
              amount: data[j].amount,
              weight: data[j].weight,
              imgPath: data[j].imgPath,
              remark: data[j].remark,
            };
            ordersGoodsList.push(obj);
          }
        } else {
          data = v;
          var obj = {
            pnumber: data[i].pnumber,
            ono: data[i].no,
            storeName: "",
            name: data[i].name,
            barCode: data[i].barCode,
            volume: data[i].volume,
            model: data[i].model,
            amount: data[i].amount,
            weight: data[i].weight,
            imgPath: data[i].imgPath,
            remark: data[i].remark,
          };
          ordersGoodsList.push(obj);
        }
      }
    },
    getdis() {
      var t = this.forms;
      for (let i = 0; i < t.length; i++) {
        if (t[i].key == "addressS" || t[i].key == "addressD") {
          this.forms[i].selectItems = this.lydic.getA("addressPrice");
        }
      }
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);

    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    //this.dingdanhao();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/anpaicheliang.vue